import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";

import { FeatureRequest } from "@app/data/feature-request";

@Injectable()
export class FeatureRequestService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  featureRequestsUrl = "api/v2/feature-requests";
  headers = { headers: this.httpHeaders };

  constructor(private httpClient: HttpClient) {}

  all(): Promise<FeatureRequest[]> {
    return this.httpClient
      .get(this.featureRequestsUrl)
      .toPromise()
      .then((response) => response as FeatureRequest[])
      .catch(this.handleError);
  }

  get(id: string): Promise<FeatureRequest> {
    const url = `${this.featureRequestsUrl}/${id}`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as FeatureRequest)
      .catch(this.handleError);
  }

  vote(id: string): Promise<FeatureRequest> {
    const url = `${this.featureRequestsUrl}/${id}/vote`;
    return this.httpClient
      .put(url, {}, this.headers)
      .toPromise()
      .then((response) => response as FeatureRequest)
      .catch(this.handleError);
  }

  create(featureRequest: FeatureRequest): Promise<FeatureRequest> {
    return this.httpClient
      .post(this.featureRequestsUrl, featureRequest, this.headers)
      .toPromise()
      .then((res) => res as FeatureRequest)
      .catch(this.handleError);
  }

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
